import React from 'react';
import s from './Loader.scss';

export class Loader extends React.Component<any, any> {
  public render() {
    return <div className={s.loader} />;
  }
}
